import React from 'react'
import './Footer.css';
import { useLanguage } from '../context/LanguageContext';

function Footer() {
  const { t } = useLanguage();
  return (
    <div className='footer'>
      <h3>{t.footer_text}</h3>


    </div>
  )
}

export default Footer